import type { PropsWithChildren } from 'react';
import { buildResponsiveProps, type ResponsiveBoxSizing } from '../../util/responsive';
import { sanitizeCSSVariables } from '../../util/style';
import { Typography } from '../typography';
import styles from './card.module.scss';

const componentStyleName = 'card-title';

interface CardTitleProps {
  padding?: ResponsiveBoxSizing;
}

export function CardTitle({ children, padding }: PropsWithChildren<CardTitleProps>) {
  const style = sanitizeCSSVariables({
    ...buildResponsiveProps(componentStyleName, 'padding-top', padding?.top, 'space'),
    ...buildResponsiveProps(componentStyleName, 'padding-right', padding?.right, 'space'),
    ...buildResponsiveProps(componentStyleName, 'padding-bottom', padding?.bottom, 'space'),
    ...buildResponsiveProps(componentStyleName, 'padding-left', padding?.left, 'space'),
  });

  return (
    <div className={styles.title} style={style}>
      <Typography inheritance="current" lineHeight="1.5rem" size="0.875rem">
        {children}
      </Typography>
    </div>
  );
}
